import * as React from 'react';
import { defaultInfoviewConfig } from '@leanprover/infoview-api';
// Type-unsafe initializers for contexts which we immediately set up at the top-level.
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
export var EditorContext = React.createContext(null);
export var VersionContext = React.createContext(undefined);
export var ConfigContext = React.createContext(defaultInfoviewConfig);
export var LspDiagnosticsContext = React.createContext(new Map());
export var ProgressContext = React.createContext(new Map());
